import { csvReader } from "../../utils/csvReader";
import { CompareSwedenData } from "./models/CompareSwedenData";

export function getDataPoints() {
    return csvReader<CompareSwedenData>("/data-sources/compare-sweden/data.csv", false);
}
